import { Component, EventEmitter, OnInit } from '@angular/core';
import { DwCardBaseComponent, DwComponent, DwComponentType, DwMediaRepositoryService, DwMetaDataListCardConfigData, DwMetaDataRoutingService, DwQueryMetaData } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames, DocumentItemEntity, DocumentItemsListQueryEntity } from '../../../../../meta-data/app-meta-data.service';


@DwComponent<DwMetaDataListCardConfigData>({
  name: 'Document Card',
  key: 'documentCard',
  componentType: DwComponentType.card,
  //configComponent: DwCardDefaultConfigComponent,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.DocumentItem,
  configData: {
  }
})
@Component({
  selector: 'app-document-card-old',
  templateUrl: './document-card-old.component.html',
  styleUrls: ['./document-card-old.component.scss']
})
export class DocumentCardOldComponent implements DwCardBaseComponent<any, DocumentItemsListQueryEntity> {
  resolvedContext?: any;
  queryMetaData?: DwQueryMetaData;
  cardClick: EventEmitter<any> = new EventEmitter<any>();

  cardConfig?: any;
  data?: DocumentItemsListQueryEntity;
  imageUrl: string;

  constructor(private dwMediaRepository: DwMediaRepositoryService,
    private dwMetaDataRoutingService: DwMetaDataRoutingService,
  ) { }


  setupCard() {
    if (this.data.UseCustomCardIcon) {
      if (this.data.MediaMediaPath) {
        this.imageUrl = this.dwMediaRepository.getImageUrlFromMediaPath(this.data.MediaMediaPath, 75, 75);
      }  
    } else {
      if (this.data.ExtractedMediaMediaPath) {
        this.imageUrl = this.dwMediaRepository.getImageUrlFromMediaPath(this.data.ExtractedMediaMediaPath, 75, 75);
      }
    }

    if (!this.imageUrl) {
      this.imageUrl = '/assets/aviator-online/img/64px-PDF_file_icon.svg.png';
    }
  }

  click() {
    this.cardClick.emit(this.data);
  }

}
